import { createRouter, createWebHistory } from "vue-router";

import Profile from "../views/Profile.vue";

import Dashboard from "../views/Dashboard.vue";

const Perangkat = () => import('../views/perangkat/index.vue')
const PerangkatInternal = () => import('../views/perangkat/internal/index.vue')
const PerangkatInternalDuplikasi = () => import('../views/perangkat/internal/Duplikasi.vue')
const PerangkatPostel = () => import('../views/perangkat/postel/index.vue')
const DownloadPostel = () => import('../views/perangkat/postel/DownloadPostel.vue')
const Gudang = () => import('../views/gudang/index.vue')
const Riwayat = () => import('../views/riwayat/index.vue')
const RiwayatUnit = () => import('../views/riwayat/unit/index.vue')
const RiwayatUpload = () => import('../views/riwayat/upload/index.vue')
const Laporan = () => import('../views/laporan/index.vue')

import Signin from "../views/Signin.vue";

const routes = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard',
    name: 'not-found',
  },
  {
    path: "/",
    redirect: "/dashboard",
    meta: {
      isAuth: true
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      isAuth: true
    }
  },
  {
    path: "/perangkat",
    name: "Perangkat",
    component: Perangkat,
    meta: {
      isAuth: true
    },
    children: [
      {
        path: "internal",
        name: "Internal",
        component: PerangkatInternal,
      },
      {
        path: "postel",
        name: "Postel",
        component: PerangkatPostel,
      },
      {
        path: "download-postel",
        name: "DownloadPostel",
        component: DownloadPostel
      }
    ]
  },
  {
    path: "/perangkat/internal/duplikasi",
    name: "Duplikasi",
    component: PerangkatInternalDuplikasi,
    meta: {
      isAuth: true
    }
  },
  {
    path: "/gudang",
    name: "Gudang",
    component: Gudang,
    meta: {
      isAuth: true
    }
  },
  {
    path: "/riwayat",
    name: "Riwayat",
    component: Riwayat,
    meta: {
      isAuth: true
    },
    children: [
      {
        path: "unit",
        name: "RiwayatUnit",
        component: RiwayatUnit,
      },
      {
        path: "upload",
        name: "RiwayatUpload",
        component: RiwayatUpload,
      },
    ]
  },
  {
    path: "/laporan",
    name: "Laporan",
    component: Laporan,
    meta: {
      isAuth: true
    }
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
    meta: {
      isAuth: false
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.isAuth)) {
    if (localStorage.getItem('user')) {
      next();
      return;
    }
    next("/signin");
  } else {
    next();
  }
});

export default router;
